/**
 * SDRR-Abierto API
 * SDRR-Abierto API.
 *
 * The version of the OpenAPI document: 1.0-SNAPSHOT
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
import { FacturaDTO } from './facturaDTO';
import { CodigoLerDTO } from './codigoLerDTO';
import { AportacionDIEstadoDTO } from './aportacionDIEstadoDTO';
import { SolicitudRetiradaDTO } from './solicitudRetiradaDTO';
import { OperacionGestionDTO } from './operacionGestionDTO';
import { GestoresResiduosDTO } from './gestoresResiduosDTO';
import { DescripcionEnvaseDTO } from './descripcionEnvaseDTO';
import { DocumentoDTO } from './documentoDTO';


export interface AportacionDISDDRCADTO { 
    fechaAlta?: string;
    creadoPor?: string;
    fechaModificacion?: string;
    modificadoPor?: string;
    id?: number;
    nima?: string;
    estado?: AportacionDIEstadoDTO;
    documentoIdentificacion?: string;
    fechaRecogida?: string;
    fechaAceptacion?: string;
    fechaAportacion?: string;
    documento?: DocumentoDTO;
    facturaGestor?: FacturaDTO;
    facturaPoseedor?: FacturaDTO;
    gestorResiduo?: GestoresResiduosDTO;
    acondicionador?: GestoresResiduosDTO;
    codigoLer?: CodigoLerDTO;
    descripcionEnvase?: DescripcionEnvaseDTO;
    operacionGestion?: OperacionGestionDTO;
    cantidadGestionada?: number;
    solicitudRetirada?: SolicitudRetiradaDTO;
    motivoRechazo?: string;
    esCreadoPoseedor?: boolean;
    nimaGestor?: string;
    razonSocialGestor?: string;
    documentoGestor?: string;
}
export namespace AportacionDISDDRCADTO {
    export type OrigenEnum = 'SDDRCC' | 'POSEEDOR' | 'SDDRCA' | 'GESTORESACUERDO';
    export const OrigenEnum = {
        Sddrcc: 'SDDRCC' as OrigenEnum,
        Poseedor: 'POSEEDOR' as OrigenEnum,
        Sddrca: 'SDDRCA' as OrigenEnum,
        Gestoresacuerdo: 'GESTORESACUERDO' as OrigenEnum
    };
}


